import { Button, Result } from "antd";
import bg from './auth_bg.png';
const BillingFailed: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-[70%] bg-cover bg-no-repeat" style={{
      backgroundImage: `url('${bg}')`, // <-- add your image path
    }}>
      <div className="flex items-center justify-center h-screen ">
        <div className="w-full max-w-lg border-2 p-4 bg-white rounded-lg shadow-lg">
          <Result
            status="error"
            title="Payment Failed"
            subTitle="Unfortunately, your payment could not be processed at this time. Please login to your account and try again."
            extra={[
              <Button key="login" type="link" href="/login" className="bg-primaryColor text-white hover:border-primaryColor hover:!text-primaryColor">
                Login to your account
              </Button>
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default BillingFailed;
